module.exports = __webpack_public_path__ + "img/horizontal.38c5355b.svg";